import type { UseFormReturn } from "react-hook-form";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

const emailVerificationFormSchema = z.object({
  verificationCode: z
    .string()
    .min(1, "Please fill in this field.")
    .length(6, "Verification code must be 6 digits.")
    .regex(/^\d{6}$/, "Verification code must contain only numbers."),
});

export type EmailVerificationFormData = z.infer<
  typeof emailVerificationFormSchema
>;

export function useEmailVerificationForm(
  initialData: EmailVerificationFormData,
): UseFormReturn<EmailVerificationFormData> {
  return useForm<EmailVerificationFormData>({
    defaultValues: {
      verificationCode: initialData.verificationCode || "",
    },
    resolver: zodResolver(emailVerificationFormSchema),
  });
}
